import { render, staticRenderFns } from "./UserBundleOrdersImport.vue?vue&type=template&id=6d9a2b24&scoped=true"
import script from "./UserBundleOrdersImport.vue?vue&type=script&lang=js"
export * from "./UserBundleOrdersImport.vue?vue&type=script&lang=js"
import style0 from "./UserBundleOrdersImport.vue?vue&type=style&index=0&id=6d9a2b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9a2b24",
  null
  
)

export default component.exports